import { useQuery } from "react-query";
import axios from "axios";
import { BessEquipmentTotalizersResponse } from "./BessTotalizersTypes";

const totalizersUrl = (equipmentId: number) => `api/bess/${equipmentId}/totalizers`;

const fetchTotalizers = async (equipmentId: number): Promise<BessEquipmentTotalizersResponse> => {
    return await axios
        .get<BessEquipmentTotalizersResponse>(totalizersUrl(equipmentId), { timeout: 30000 })
        .then((res) => res.data);
};

export const useBessEquipmentTotalizers = (equipmentId: number) => {
    return useQuery({
        queryKey: ["bess-equipment-totalizers", equipmentId],
        queryFn: () => fetchTotalizers(equipmentId),
        enabled: Boolean(equipmentId),
    });
};
